<template>
    <td :colspan="headers.length">
        <v-row
            v-if="!question"
            justify="center"
        >
            <v-col cols="4">
                <v-progress-linear indeterminate></v-progress-linear>
            </v-col>
        </v-row>

        <div
            v-else
            class="mx-8 my-4"
        >
            <v-row class="mb-4">
                <v-col class="text-center">{{ question.label }}</v-col>
                <v-col class="text-center">{{ question.field }}</v-col>
            </v-row>

            <v-row
                v-if="questionImage"
                justify="center"
                class="mb-4"
            >
                <v-img
                    :src="questionImage"
                    max-width="400"
                    max-height="400"
                    contain
                ></v-img>
            </v-row>

            <p>
                {{ question.question }}
            </p>

            <ol
                type="A"
                class="mb-4"
            >
                <li
                    v-for="answer in question.answers"
                    :key="answer.id"
                    :class="{ 'primary--text': answer.correct }"
                >
                    {{ answer.answer }}
                </li>
            </ol>

            <v-row
                v-if="question.explanation_video_id"
                justify="center"
            >
                <youtube :video-id="question.explanation_video_id"></youtube>
            </v-row>

            <v-row
                v-if="question.explanation_images.length > 0"
                justify="center"
            >
                <v-img
                    v-for="(image, i) in explanationImages"
                    :key="i"
                    :src="image"
                    max-width="400"
                    max-height="400"
                    contain
                    class="ma-2"
                ></v-img>
            </v-row>
        </div>
    </td>
</template>

<script>
import assetUrl from '@/tools/assetUrl'

export default {
    props: ['headers', 'item'],

    data() {
        return {
            question: null,
        }
    },

    computed: {
        expandedItem() {
            return this.item[0]
        },

        questionImage() {
            if (this.question.image) {
                return assetUrl(this.question.image)
            }

            return null
        },

        explanationImages() {
            return this.question.explanation_images.map((e) => assetUrl(e))
        },
    },

    watch: {
        item() {
            this.getQuestion()
        },
    },

    methods: {
        getQuestion() {
            this.question = null

            this.$api
                .get(
                    `questionbank/${this.$route.params.questionbank_id}/question/${this.expandedItem.id}`
                )
                .then((response) => {
                    this.question = response.data
                })
        },
    },

    created() {
        this.getQuestion()
    },
}
</script>
